import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import boardDefReducer from './boardDef'
import boardDefsReducer from './boardDefs'
import commentsReducer from './comments'
import taskLinksReducer from './taskLinks'
import taskChecklistItemsReducer from './taskChecklistItems'
import projectReducer from './project'
import projectMembersReducer from './projectMembers'
import feedbackReducer from './feedback'
import authorizationReducer from './authorization'
import userInfoReducer from './userinfo'
import taskFilterReducer from './taskFilter'
import { tasksReducer, taskMappingsReducer } from './tasks'
import { reducer as toastrReducer } from 'react-redux-toastr'
import resourcesReducer from './resources'
import addTaskReducer from './addTask'
import { configReducer } from './config'
import editorReducer from './editor'

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    editor: editorReducer,
    boardDef: boardDefReducer,
    boardDefs: boardDefsReducer,
    comments: commentsReducer,
    taskFilter: taskFilterReducer,
    taskLinks: taskLinksReducer,
    taskChecklistItems: taskChecklistItemsReducer,
    project: projectReducer,
    projectMembers: projectMembersReducer,
    feedback: feedbackReducer,
    taskMappings: taskMappingsReducer,
    tasks: tasksReducer,
    addTask: addTaskReducer,
    resources: resourcesReducer,
    routing: routerReducer,
    authorization: authorizationReducer,
    userInfo: userInfoReducer,
    toastr: toastrReducer,
    config: configReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js